import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 0;

  .icon {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    svg { color: #94a3b8; }
  }

  .text {
    font-size: 0.8rem;
    color: #475569;
    text-transform: capitalize;
  }
`;

export default Wrapper;
